// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-helpfile-tsx": () => import("./../../../src/components/Helpfile.tsx" /* webpackChunkName: "component---src-components-helpfile-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

